// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-i_gy","advertDetailContactItem__link":"c-i_gz"};